import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import DocumentsReportsListView from "./documents_reports-list.html";
import DocumentsReportsEditView from "./documents_reports-edit.html";


angular.module("documents_reports", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('documents_reports', {
                url: "/documents_reports",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('documents_reports.list', {
                url: "/list",
                controller: "DocumentsReportsListCtrl",
                template: DocumentsReportsListView,
                params: { reset: null },
                data: { pageTitle: 'Documentos' }
            })
            .state('documents_reports.edit', {
                url: "/edit/:id",
                controller: "DocumentsReportsEditCtrl",
                template: DocumentsReportsEditView,
                data: { pageTitle: 'Documentos' }
            })
            ;
    }])
    ;